import React from 'react';
import Lottie from 'react-lottie';
import * as animationData from 'lottie/login.json';

const LoginLogo = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData.default,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  if (process.env.REACT_APP_THEME === 'NETWORK_COMMANDER') {
    return null;
  }

  const renderLogo = () => {
    switch (process.env.REACT_APP_THEME) {
      case 'WORKSPACEGEEK':
        return (
          <div className="workspace-geek-logo">
            <img src="/workspace-geek-logo.png" alt="Workspace Geek Logo" />
          </div>
        );
      case '640TECH':
        return (
          <div className="640tech-logo">
            <img
              src="/640-tech-logo-light.png"
              alt="640Tech Logo"
              width={450}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return <div className="login-logo-container">{renderLogo()}</div>;
};

export default LoginLogo;
